module.exports = __webpack_public_path__ + "static/3reductionsarrow_chart_mobile-a253bcc08f8f9bfeb2c482edaf37affa.png";